// 多语言文本配置文件
// 为将来多语言支持做准备
// 引入需要在配置中直接引用的图片资源（便于集中管理）
import carImage1 from "../images/carimage/aerfa.png"
import carImage2 from "../images/carimage/haishi.png"
import carImage3 from "../images/carimage/kaosite.png"
import carImage4 from "../images/carimage/sanlingxiaobus.png"
import carImage5 from "../images/carimage/sanlingdabus.png"

import seat7 from "../images/carimagezuowei/7site.png"
import seat10 from "../images/carimagezuowei/10site.png"
import seat18 from "../images/carimagezuowei/18site.png"
import seat30 from "../images/carimagezuowei/30site.png"
import seat60 from "../images/carimagezuowei/60site.png"

const texts = {
  // 默认语言：中文
  zh: {
    // ===== 页头部分 =====
    // 公司基本信息（全站通用）
    company: {
      name: "ARESCOJP株式会社",
      slogan: "日本专业旅游服务平台",
      contact: {
        phone: "080-4779-8044",
        fax: "+81-42-497-1567",
        email: "info@arescojp.com"
      }
    },
    // 页头导航
    header: {
      // 顶部联系信息
      topHeader: {
        phoneAlt: "电话图标",
        faxAlt: "传真图标",
        bookingButton: "🚗 预订汽车"

      },
      // 主导航菜单
      navigation: {
        home: "主页",
        carbooking: "包车介绍",
        grouptravel: "团体攻略",
        hotelbooking: "旅馆・民宿预订",
        question: "常见问题",
        contact: "联系我们",
        companyprofile: "公司简介"
      }
    },

    // ===== 各页面内容 =====

    // 首页
    homepage: {
      title: {
        main: "Travel",
        subtitle: "日本专业旅游服务平台"
      },
      scrollingBar: "🌸 欢迎来到ARESCOJP日本专业旅游服务平台 🎌 提供包车服务、酒店预订、旅游咨询等一站式服务 📞 电话咨询：080-4779-8044 ✉️ 邮箱：info@arescojp.com 🚗 专业司机、安全可靠 🏨 精选优质住宿 🗾 量身定制旅行路线"
    },

    // 酒店预订页面
    hotelbooking: {
      title: "酒店预订",
      pageTitle: "精选酒店预订",
      subtitle: "我们与日本各地优质酒店合作，为您提供最优惠的价格和贴心的服务",
      consultation: {
        title: "专业顾问为您服务",
        description: "扫描下方二维码，添加我们的企业微信",
        subdescription: "获取最新优惠信息和专属预订服务",
        wechatLabel: "企业微信",
        features: {
          response: {
            icon: "⚡",
            title: "快速响应",
            description: "工作时间内5分钟回复"
          },
          price: {
            icon: "💰",
            title: "优惠价格",
            description: "团体预订享受折扣"
          },
          custom: {
            icon: "🎯",
            title: "定制服务",
            description: "根据需求推荐酒店"
          }
        }
      },
      hotels: [
        {
          id: 1,
          name: "东京希尔顿酒店",
          location: "新宿区",
          features: ["温泉", "健身房", "商务中心"],
          image: "🏨"
        },
        {
          id: 2,
          name: "京都四季酒店",
          location: "东山区",
          features: ["日式庭园", "茶室", "米其林餐厅"],
          image: "🏯"
        },
        {
          id: 3,
          name: "大阪万豪酒店",
          location: "阿倍野区",
          features: ["空中酒吧", "无边泳池", "观景台"],
          image: "🌆"
        },
        {
          id: 4,
          name: "箱根温泉旅馆",
          location: "箱根町",
          features: ["私人温泉", "传统料理", "富士山景"],
          image: "♨️"
        },
        {
          id: 5,
          name: "札幌格兰酒店",
          location: "中央区",
          features: ["滑雪场接送", "温泉", "海鲜料理"],
          image: "❄️"
        },
        {
          id: 6,
          name: "冲绳海滨度假村",
          location: "恩纳村",
          features: ["私人海滩", "水上运动", "SPA中心"],
          image: "🏖️"
        }
      ]
    },

    // 包车预订页面
    carbooking: {
      title: "包车预订",
      // 车辆信息（文案与图片集中配置）
      vehicles: [
        {
          model: "7正座 (丰田阿尔法)",
          recommended: "适合1-6位客人",
          max: "6",
          seats: "7正座 (包括司机)",
          length: "5米",
          luggage: "1-6件 (26寸行李箱)",
          images: { vehicle: carImage1, seats: seat7 },
        },
        {
          model: "10人座 (丰田海狮)",
          recommended: "适合5-9位客人",
          max: "9",
          seats: "10正座 (包括司机座位)",
          length: "5.3米",
          luggage: "1-10件 (26寸行李箱)",
          images: { vehicle: carImage2, seats: seat10 },
        },
        {
          model: "18正座+5副座 (丰田考斯特)",
          recommended: "适合10-17位客人",
          max: "22",
          seats: "18正座 (包括司机座位) +5个副座",
          length: "7米",
          luggage: "1-17件 (26寸行李箱)",
          images: { vehicle: carImage3, seats: seat18 },
        },
        {
          model: "28正座（三菱小巴）",
          recommended: "适合20〜28位客人",
          max: "28",
          seats: "30正座（包括司机座位）",
          length: "9米",
          luggage: "1-25件 (26寸行李箱)",
          images: { vehicle: carImage4, seats: seat30 },
        },
        {
          model: "49正座＋11副座（三菱大巴）",
          recommended: "适合49〜60位客人",
          max: "60",
          seats: "50正座（包括司机座位)＋11副座",
          length: "12米",
          luggage: "1-35件 (26寸行李箱)",
          images: { vehicle: carImage5, seats: seat60 },
        },
      ],

      // 预约表单文案（包车/接送机）
      reservation: {
        serviceTypeLabel: "服务类型",
        serviceTypeOptions: {
          charter: "包车游",
          transfer: "接送机",
        },

        // 包车游字段标签
        charter: {
          labels: {
            name: "名字",
            phone: "电话号码",
            phoneCountryPlaceholder: "国家区号",
            phoneNumberPlaceholder: "号码",
            wechat: "微信ID",
            hotel: "酒店名称",
            email: "邮箱地址",
            passengers: "人数",
            startTime: "开始时间",
            endTime: "结束时间",
            notes: "备注",
          }
        },

        // 接送机字段标签与选项
        transfer: {
          kindLabel: "接送类型",
          kindOptions: {
            pickup: "接机",
            dropoff: "送机",
          },
          routeLabel: "机场线路",
          routes: [
            "成田机场",
            "羽田机场",
            "关西机场",
            "新千岁机场",
            "福冈机场",
            "那霸机场",
            "其他机场（备注里注明）",
          ],
          labels: {
            name: "名字",
            passengers: "人数",
            luggage: "行李数量",
            phone: "电话号码",
            phoneCountryPlaceholder: "国家区号",
            phoneNumberPlaceholder: "号码",
            wechat: "微信ID",
            hotel: "酒店名称",
            email: "邮箱地址",
            flightNo: "航班号",
            flightTime: "航班时间",
            notes: "备注",
          }
        },

        // 电话区号（常见亚洲/欧洲/北美）
        phone: {
          countryOptions: [
            { value: "+81", label: "+81 日本" },
            { value: "+86", label: "+86 中国" },
            { value: "+852", label: "+852 中国香港" },
            { value: "+853", label: "+853 中国澳门" },
            { value: "+886", label: "+886 中国台湾" },
            { value: "+82", label: "+82 韩国" },
            { value: "+65", label: "+65 新加坡" },
            { value: "+60", label: "+60 马来西亚" },
            { value: "+62", label: "+62 印度尼西亚" },
            { value: "+63", label: "+63 菲律宾" },
            { value: "+66", label: "+66 泰国" },
            { value: "+84", label: "+84 越南" },
            { value: "+91", label: "+91 印度" },
            { value: "+92", label: "+92 巴基斯坦" },
            { value: "+94", label: "+94 斯里兰卡" },
            { value: "+95", label: "+95 缅甸" },
            { value: "+880", label: "+880 孟加拉国" },
            { value: "+976", label: "+976 蒙古" },
            { value: "+977", label: "+977 尼泊尔" },
            { value: "+855", label: "+855 柬埔寨" },
            { value: "+856", label: "+856 老挝" },
            { value: "+673", label: "+673 文莱" },
            { value: "+971", label: "+971 阿联酋" },
            { value: "+972", label: "+972 以色列" },
            { value: "+974", label: "+974 卡塔尔" },
            { value: "+973", label: "+973 巴林" },
            { value: "+968", label: "+968 阿曼" },
            { value: "+965", label: "+965 科威特" },
            { value: "+964", label: "+964 伊拉克" },
            { value: "+98", label: "+98 伊朗" },
            { value: "+90", label: "+90 土耳其" },
            { value: "+994", label: "+994 阿塞拜疆" },
            { value: "+995", label: "+995 格鲁吉亚" },
            { value: "+996", label: "+996 吉尔吉斯斯坦" },
            { value: "+998", label: "+998 乌兹别克斯坦" },
            { value: "+993", label: "+993 土库曼斯坦" },
            { value: "+992", label: "+992 塔吉克斯坦" },
            { value: "+44", label: "+44 英国" },
            { value: "+49", label: "+49 德国" },
            { value: "+33", label: "+33 法国" },
            { value: "+39", label: "+39 意大利" },
            { value: "+34", label: "+34 西班牙" },
            { value: "+31", label: "+31 荷兰" },
            { value: "+32", label: "+32 比利时" },
            { value: "+41", label: "+41 瑞士" },
            { value: "+43", label: "+43 奥地利" },
            { value: "+46", label: "+46 瑞典" },
            { value: "+47", label: "+47 挪威" },
            { value: "+45", label: "+45 丹麦" },
            { value: "+48", label: "+48 波兰" },
            { value: "+36", label: "+36 匈牙利" },
            { value: "+420", label: "+420 捷克" },
            { value: "+421", label: "+421 斯洛伐克" },
            { value: "+40", label: "+40 罗马尼亚" },
            { value: "+359", label: "+359 保加利亚" },
            { value: "+30", label: "+30 希腊" },
            { value: "+351", label: "+351 葡萄牙" },
            { value: "+353", label: "+353 爱尔兰" },
            { value: "+358", label: "+358 芬兰" },
            { value: "+380", label: "+380 乌克兰" },
            { value: "+375", label: "+375 白俄罗斯" },
            { value: "+354", label: "+354 冰岛" },
            { value: "+386", label: "+386 斯洛文尼亚" },
            { value: "+385", label: "+385 克罗地亚" },
            { value: "+372", label: "+372 爱沙尼亚" },
            { value: "+371", label: "+371 拉脱维亚" },
            { value: "+370", label: "+370 立陶宛" },
            { value: "+357", label: "+357 塞浦路斯" },
            { value: "+356", label: "+356 马耳他" },
            { value: "+1", label: "+1 美国/加拿大" },
          ]
        },

        submitLabel: "提交预约",
        submitLoading: "提交中...",
        
       
      },
      successMessage: "预订已成功提交！我们将通过您选择的联系方式与您联系确认详情。",
      submitError: "提交失败",
      // 页面静态文案（车型卡片中的标签与按钮）
      cardLabels: {
        seat: "正座",
        recommended: "推荐乘客",
        luggage: "行李数",
        remarkPrefix: "备注",
        remarkText: "行李等请在使用时咨询",
        maxNoLuggageSuffix: "人",
        bookNow: "立即预订",
      },
      
  
      
      // 价格说明
      priceIncluded: "标示价格包括：",
      priceIncludedItems: "车辆使用费，司机工资。",
      priceExcluded: "不包括：",
      priceExcludedItems: "高速费，停车费，住宿费(8000日元/晚)，回送费，司机餐补费(3000日元/天)，司机加班费。",
      priceEstimate: "如果每天用车300公里以内，工作时间为10小时以内，高速费，停车费，住宿费，回送费，司机餐补费大概每日15000日元左右。",
      
      // 订金说明
      depositDescription: "预约成功之后，客服将联系您并收取订金，订金为费用的30%。",
      
      // 特殊用品
      specialItemsDescription: "如果需要婴幼儿安全座椅，轮椅，婴儿车等请在用车行程里备注说明。需额外加费用。",
      specialItemsPricing: "轮椅：1千日元/天，婴儿座椅：1千日元/天，婴儿车：2千日元/天。",
      specialItemsPayment: "可直接付款给当天司机，这些额外费用需要领收书也请提早说明。",
      
      // 车厅规定
      regulationsDescription: "车厅内禁止用餐，为了各位游客旅途的舒适，不造成其他游客的不适，晕车呕吐等情况，请不要在车厅内食用，携带气味大的食品。谢谢理解和配合。",
      
      // 超时说明  
      overtimeDescription: "我们时间是以10小时工作为准。超时按15分钟起算，不足15分钟按照15分钟计算。",
      overtimeRate: "每超时15分钟按日元1250加算。",
    },
    // 常见问题页面
    question: {
      title: "常见问题",
      subtitle: "为您解答日本旅游服务的常见疑问",
      faqs: [
        {
          id: 1,
          question: "包车服务的预订流程是什么？",
          answer: "包车服务预订流程很简单：1. 选择您需要的车型和日期；2. 填写详细的出行信息和联系方式；3. 我们的客服人员会在24小时内与您联系确认行程；4. 支付订金后预订完成。我们提供专业的司机和安全的车辆，确保您的日本之旅舒适愉快。"
        },
        {
          id: 2,
          question: "酒店预订需要提前多长时间？",
          answer: "建议您至少提前3-7天预订酒店，特别是在樱花季、红叶季等旅游旺季时，建议提前2-4周预订。我们会根据您的需求和预算为您推荐合适的酒店，包括传统日式旅馆、商务酒店、度假村等多种选择。预订确认后，我们会发送详细的入住信息给您。"
        },
        {
          id: 3,
          question: "如何联系客服或取消预订？",
          answer: "您可以通过多种方式联系我们：微信、LINE、邮件或电话。我们的客服团队会在工作时间内及时回复您的咨询。关于取消预订，请在出行前48小时联系我们，我们会根据具体情况处理退款事宜。紧急情况下可以随时联系我们的24小时客服热线。"
        }
      ],
      contactSection: {
        title: "还有其他问题？",
        description: "如果您还有其他疑问，请随时联系我们的客服团队",
        button: "联系我们"
      }
    },
    // 联系页面
    contact: {
      title: "联系我们",
      menu: {
        whatsapp: "WhatsApp",
        wechat: "WeChat",
        mail: "Mail"
      },
      whatsapp: {
        title: "WhatsApp咨询",
        description: "请扫描上方二维码通过WhatsApp联系我们"
      },
      wechat: {
        title: "微信咨询",
        description: "请扫描上方二维码通过微信联系我们"
      },
      mail: {
        title: "邮件咨询",
        nameLabel: "姓名",
        namePlaceholder: "请输入您的姓名",
        emailLabel: "邮箱地址",
        emailPlaceholder: "example@email.com",
        messageLabel: "咨询内容",
        messagePlaceholder: "请详细描述您的咨询内容",
        submit: "发送",
        success: "消息发送成功！"
      },
    },
    // 公司简介页面
    companyProfile: {
      title: "公司简介",
      presidentMessage: {
        title: "代表致辞",
        presidentName: "李 阳阳",
        presidentTitle: "代表取缔役社长",
        paragraph1: "感谢您访问ARESCOJP株式会社的官方网站。",
        paragraph2: "自2024年成立以来，我们一直致力于为客户提供安心、安全、舒适的旅行体验，这是我们在日本国内外旅行服务业的使命。特别是随着近年来入境旅游的扩大，我们致力于为海外客户充分感受日本魅力提供细致入微的服务和专业知识支持。",
        paragraph3: "我们不仅仅提供交通工具和服务，更重视为每一位客户创造难忘的特殊时光。在包车服务、住宿安排、观光导游、口译翻译等旅行相关的各个领域，我们的专业团队将满足客户的各种需求。",
        paragraph4: "今后，在不断变化的旅游业中，我们将继续融合创新服务与传统的待客之心，努力提供让客户更加满意的服务。",
        signatureCompany: "ARESCOJP株式会社",
        signaturePosition: "代表取缔役社长　李 阳阳"
      },
      companyInfo: {
        labels: {
          companyName: "公司名称",
          established: "成立时间",
          headquarters: "总公司",
          business: "业务内容",
          representative: "代表人",
          capital: "注册资本"
        },
        values: {
          companyName: "株式会社ARES",
          established: "2024年6月6日",
          headquarters: "〒107-0062\n東京都港区南青山3-1-36青山丸竹ビル6F",
          business: "1. 各类咨询业务\n2. 各类活动的策划、制作及实施\n3. 各类商品的企划、研究、开发、生产、销售\n4. 饮食店、料理店的经营及管理\n5. 酒类的零售、批发及进出口\n6. 不动产的持有、买卖、租赁、居间、媒介\n7. 依据《旅行业法》的旅行业务\n8. 酒店、旅馆等住宿、观光及娱乐设施的经营\n9. 劳务派遣业务及有偿职业介绍业务\n10. 一般乘用旅客汽车运输、一般货物汽车运输及轻型货物汽车运输业务\n11. 汽车、二手车等车辆的销售、租赁\n12. 美容教室、整骨/整体院、理发店、美容院、美容沙龙的经营\n13. 与医疗旅游相关的研讨会策划\n14. 贸易业\n15. 依据《古物营业法》的古物买卖及进出口\n16. 电子商务（EC）网站及其他各类内容的发布、运营及管理\n17. 影像/视频内容及利用SNS的营销业务\n18. IT相关业务\n19. 上述各项附带相关的一切业务",
          representative: "法人代表　李　阳阳",
          capital: "6，660，000日元"
        }
      },
      location: {
        title: "公司地址",
        subtitle: "📍 交通信息",
        address: "〒107-0062 東京都港区南青山3-1-36青山丸竹ビル6F\nTel: 080-4779-8044",
        stations: "最寄り駅：\n• 東京メトロ銀座線『外苑前駅』300m 徒歩6分\n• 東京メトロ千代田線『表参道駅』550m 徒歩9分（A3出口）"
      },
      achievements: {
        title: "服务成绩",
        tableHeaders: {
          year: "年份",
          groupTours: "接待团数",
          totalPeople: "服务总人数"
        },
        data: [
          {
            year: "2024年",
            groupTours: "15团",
            totalPeople: "423人"
          }
        ]
      }
    },
    // 团体攻略页面
    grouptravel: {
      title: "团体攻略",
      subtitle: "精选日本旅游攻略，助您畅游日本",
      
      // 卡片组件文字
      duration: "行程：",
      
      // 分页组件文字
      paginationInfo: "第 {currentPage} 页 / 共 {totalPages} 页",
      previousPage: "上一页",
      nextPage: "下一页",
      
      // 详情页面文字
      backToList: "← 返回攻略列表",
      returnToList: "返回攻略列表",
      notFoundTitle: "攻略不存在",
      notFoundText: "抱歉，您访问的旅游攻略不存在或已被删除。",
      relatedTitle: "相关推荐",
      
      // 元信息标签
      durationLabel: "行程时间：",
      difficultyLabel: "难度等级：",
      travelGuides: [
        {
          id: "tokyo-guide",
          title: "「霓虹本州」大阪东京6日游",
          subtitle: "阪进东出",
          image: "/images/grouptravel/Top.png",
          summary: "大阪-京都-奈良-富士山-东京",
          content: `
            <h2>本州精华6日游行程详情</h2>
            <p>从关西到关东，深度体验日本传统文化与现代都市的完美融合。本行程涵盖日本最精华的城市和景点。</p>
            
            <h3>第1天：大阪</h3>
            <p>抵达关西机场，游览大阪城公园、心斋桥商业街、道顿堀美食街。品尝大阪烧、章鱼小丸子等当地美食。</p>
            
            <h3>第2天：京都</h3>
            <p>参观清水寺、金阁寺、伏见稻荷大社，体验传统和服，漫步祗园花见小路，感受千年古都的魅力。</p>
            
            <h3>第3天：奈良</h3>
            <p>游览东大寺、春日大社，与奈良公园的小鹿亲密接触，品尝柿叶寿司等奈良特色料理。</p>
            
            <h3>第4天：富士山</h3>
            <p>前往富士山五合目（视天气情况），游览忍野八海、河口湖，远眺富士山美景，入住温泉酒店。</p>
            
            <h3>第5天：东京</h3>
            <p>游览浅草寺、东京晴空塔、银座购物区、新宿商圈，体验东京的繁华与活力。</p>
            
            <h3>第6天：东京-返程</h3>
            <p>自由活动时间，可选择迪士尼乐园、台场等景点，下午前往成田机场返程。</p>
            
            <h3>费用包含</h3>
            <p>往返机票、全程酒店住宿、专业中文导游、豪华旅游巴士、行程内景点门票、旅游保险。</p>
            
            <h3>温馨提示</h3>
            <p>建议携带日币现金、准备舒适的步行鞋、提前了解各地天气情况。</p>
          `,
          tags: ["城市", "文化","美食"],
          duration: "6天",
          difficulty: "轻松游"
        }
      ],
      pagination: {
        info: "第 {currentPage} 页 / 共 {totalPages} 页",
        previous: "上一页",
        next: "下一页"
      }
    },
    // ===== 页脚部分 =====
    footer: {
      subtitle: "日本专业旅游服务平台",
      services: {
        title: "我们的服务",
        items: {
          carbooking: "包车服务 →",
          grouptravel: "团体攻略 →",
          hotelbooking: "酒店预订 →",
          contact: "联系我们 →",
          travelguide: "旅游攻略 →",
          faq: "常见问题 →"
        }
      },
      address: {
        title: "会社所在地",
        postal: "〒107-0062",
        city: "東京都港区南青山3-1-36",
        building: "青山丸竹ビル6F"
      },
      social: {
        title: "关注我们",
        phone: "080-4779-8044",
        email: "info@arescojp.com"
      },
      copyright: "© Copyright 2025 ARESCOJP株式会社, All rights Reserved."
    },

    // ===== 公共元素 =====

    common: {
      loading: "加载中...",
      error: "发生错误", 
      retry: "重试",
      errorModal: {
        title: "提交失败",
        actions: {
          cancel: "取消",
          retry: "重试"
        }
      },
      // 通用预约条款（保持不变）
      bookingTerms: {
        title: "预约须知",
        notice: "为了为您提供更好的服务，请务必填写有效联系方式，方便工作人员与您沟通。若无法取得联系，订单将被取消。",
        sections: {
          purpose: {
            title: "个人信息的使用目的",
            description: "从客户处收到的个人信息将仅用于以下目的。",
            items: {
              common: [
                "本服务的顾客管理",
                "本服务的运营所需事项的沟通"
              ],
              hotel: "酒店预订服务的提供",
              car: "包车服务的提供"
            }
          },
          provision: {
            title: "关于提供个人信息",
            description: "除非获得您的同意或法律要求，我们不会将所获取的个人信息提供给第三方。"
          },
          delegation: {
            title: "关于个人信息的委托", 
            description: "本公司可能会在达到使用目的所需的范围内将个人信息委托给外部方。我们将采取与这些分包商签订个人信息保护协议等措施，并进行适当的监督。"
          },
          security: {
            title: "个人信息的安全管理",
            description: "本公司将采取适当的安全管理措施，防止个人信息泄露。"
          },
          consequences: {
            title: "不提供个人信息的后果",
            description: "请注意，如果我们没有收到必要的信息，我们可能无法为您提供相应的服务。"
          },
          procedures: {
            title: "个人信息的公开、更正、删除、停止使用的程序",
            description: "我公司制定了披露、更正、删除和暂停使用客户个人信息的程序。我们将在确认您的身份后回复您。有关披露、更正、删除或暂停使用个人信息的具体程序，请通过电话与我们联系。"
          }
        },
        agreement: "我已阅读并同意上述预约须知和个人信息使用条款"
      }
    }
  },

  // 日语版本
  ja: {
    // ===== ヘッダー部分 =====
    // 会社基本情報（全サイト共通）
    company: {
      name: "ARESCOJP株式会社",
      slogan: "日本専門旅行サービスプラットフォーム",
      contact: {
        phone: "080-4779-8044",
        fax: "+81-42-497-1567",
        email: "info@arescojp.com"
      }
    },
    // ヘッダーナビゲーション
    header: {
      // トップヘッダー連絡先情報
      topHeader: {
        phoneAlt: "電話アイコン",
        faxAlt: "FAXアイコン",
        bookingButton: "🚗 車両予約"
      },
      // メインナビゲーションメニュー
      navigation: {
        home: "ホーム",
        carbooking: "貸切サービス",
        grouptravel: "団体ガイド",
        hotelbooking: "宿泊予約",
        question: "よくある質問",
        contact: "お問い合わせ",
        companyprofile: "会社概要"
      }
    },

    // ===== 各ページコンテンツ =====

    // トップページ
    homepage: {
      title: {
        main: "Travel",
        subtitle: "日本専門旅行サービスプラットフォーム"
      },
      scrollingBar: "🌸 ARESCOJP日本専門旅行サービスプラットフォームへようこそ 🎌 貸切サービス、ホテル予約、旅行相談などワンストップサービスを提供 📞 お電話でのお問い合わせ：080-4779-8044 ✉️ メール：info@arescojp.com 🚗 専門ドライバー、安全で信頼できる 🏨 厳選された優良宿泊施設 🗾 オーダーメイド旅行プラン"
    },

    // 貸切予約ページ
    carbooking: {
      title: "貸切予約",
      // 車両情報（文言と画像の集中管理）
      vehicles: [
        {
          model: "7正座（トヨタ アルファード）",
          recommended: "1〜6名におすすめ",
          max: "6",
          seats: "7正座（運転席含む）",
          length: "全長 5m",
          luggage: "1〜6個（26インチスーツケース）",
          images: { vehicle: carImage1, seats: seat7 },
        },
        {
          model: "10人乗り（トヨタ ハイエース）",
          recommended: "5〜9名におすすめ",
          max: "9",
          seats: "10正座（運転席含む）",
          length: "全長 5.3m",
          luggage: "1〜10個（26インチスーツケース）",
          images: { vehicle: carImage2, seats: seat10 },
        },
        {
          model: "18正座＋補助席5（トヨタ コースター）",
          recommended: "10〜19名におすすめ",
          max: "22",
          seats: "18正座（運転席含む）＋補助席5",
          length: "全長 7m",
          luggage: "1〜17個（26インチスーツケース）",
          images: { vehicle: carImage3, seats: seat18 },
        },
        {
          model: "28正座（三菱バス）",
          recommended: "20〜28名におすすめ",
          max: "28",
          seats: "30正座（運転席含む）",
          length: "全長 9m",
          luggage: "1〜25個（26インチスーツケース）",
          images: { vehicle: carImage4, seats: seat30 },
        },
        {
          model: "49正座＋補助席11（三菱バス）",
          recommended: "49〜60名におすすめ",
          max: "60",
          seats: "50正座（運転席含む）＋補助席11",
          length: "全長 12m",
          luggage: "1〜35個（26インチスーツケース）",
          images: { vehicle: carImage5, seats: seat60 },
        },
      ],

      // 予約フォーム文言（貸切／空港送迎）
      reservation: {
        serviceTypeLabel: "サービス種別",
        serviceTypeOptions: {
          charter: "貸切観光",
          transfer: "空港送迎",
        },
        charter: {
          labels: {
            name: "お名前",
            phone: "電話番号",
            phoneCountryPlaceholder: "国番号",
            phoneNumberPlaceholder: "番号",
            wechat: "WeChat ID",
            hotel: "ホテル名",
            email: "メールアドレス",
            passengers: "人数",
            startTime: "開始時間",
            endTime: "終了時間",
            notes: "備考",
          }
        },
        transfer: {
          kindLabel: "送迎種別",
          kindOptions: {
            pickup: "お迎え（到着）",
            dropoff: "お送り（出発）",
          },
          routeLabel: "空港ルート",
          routes: [
            "成田空港",
            "羽田空港",
            "関西空港",
            "新千歳空港",
            "福岡空港",
            "那覇空港",
            "その他（備考にメモ）",
          ],
          labels: {
            name: "お名前",
            passengers: "人数",
            luggage: "荷物個数",
            phone: "電話番号",
            phoneCountryPlaceholder: "国番号",
            phoneNumberPlaceholder: "番号",
            wechat: "WeChat ID",
            hotel: "ホテル名",
            email: "メールアドレス",
            flightNo: "便名",
            flightTime: "フライト時刻",
            notes: "備考",
          }
        },
        phone: {
          countryOptions: [
            { value: "+81", label: "+81 日本" },
            { value: "+86", label: "+86 中国" },
            { value: "+852", label: "+852 香港" },
            { value: "+853", label: "+853 マカオ" },
            { value: "+886", label: "+886 台湾" },
            { value: "+82", label: "+82 韓国" },
            { value: "+65", label: "+65 シンガポール" },
            { value: "+60", label: "+60 マレーシア" },
            { value: "+62", label: "+62 インドネシア" },
            { value: "+63", label: "+63 フィリピン" },
            { value: "+66", label: "+66 タイ" },
            { value: "+84", label: "+84 ベトナム" },
            { value: "+91", label: "+91 インド" },
            { value: "+92", label: "+92 パキスタン" },
            { value: "+94", label: "+94 スリランカ" },
            { value: "+95", label: "+95 ミャンマー" },
            { value: "+880", label: "+880 バングラデシュ" },
            { value: "+976", label: "+976 モンゴル" },
            { value: "+977", label: "+977 ネパール" },
            { value: "+855", label: "+855 カンボジア" },
            { value: "+856", label: "+856 ラオス" },
            { value: "+673", label: "+673 ブルネイ" },
            { value: "+971", label: "+971 アラブ首長国連邦" },
            { value: "+972", label: "+972 イスラエル" },
            { value: "+974", label: "+974 カタール" },
            { value: "+973", label: "+973 バーレーン" },
            { value: "+968", label: "+968 オマーン" },
            { value: "+965", label: "+965 クウェート" },
            { value: "+964", label: "+964 イラク" },
            { value: "+98", label: "+98 イラン" },
            { value: "+90", label: "+90 トルコ" },
            { value: "+44", label: "+44 英国" },
            { value: "+49", label: "+49 ドイツ" },
            { value: "+33", label: "+33 フランス" },
            { value: "+39", label: "+39 イタリア" },
            { value: "+34", label: "+34 スペイン" },
            { value: "+31", label: "+31 オランダ" },
            { value: "+32", label: "+32 ベルギー" },
            { value: "+41", label: "+41 スイス" },
            { value: "+43", label: "+43 オーストリア" },
            { value: "+46", label: "+46 スウェーデン" },
            { value: "+47", label: "+47 ノルウェー" },
            { value: "+45", label: "+45 デンマーク" },
            { value: "+48", label: "+48 ポーランド" },
            { value: "+36", label: "+36 ハンガリー" },
            { value: "+420", label: "+420 チェコ" },
            { value: "+421", label: "+421 スロバキア" },
            { value: "+40", label: "+40 ルーマニア" },
            { value: "+359", label: "+359 ブルガリア" },
            { value: "+30", label: "+30 ギリシャ" },
            { value: "+351", label: "+351 ポルトガル" },
            { value: "+353", label: "+353 アイルランド" },
            { value: "+358", label: "+358 フィンランド" },
            { value: "+380", label: "+380 ウクライナ" },
            { value: "+375", label: "+375 ベラルーシ" },
            { value: "+354", label: "+354 アイスランド" },
            { value: "+386", label: "+386 スロベニア" },
            { value: "+385", label: "+385 クロアチア" },
            { value: "+372", label: "+372 エストニア" },
            { value: "+371", label: "+371 ラトビア" },
            { value: "+370", label: "+370 リトアニア" },
            { value: "+357", label: "+357 キプロス" },
            { value: "+356", label: "+356 マルタ" },
            { value: "+1", label: "+1 米国/カナダ" },
          ]
        },
        submitLabel: "予約を送信",
        submitLoading: "送信中...",
      },

      // カード内ラベル
      cardLabels: {
        seat: "正座",
        recommended: "推奨人数",
        luggage: "荷物数",
        remarkPrefix: "備考",
        remarkText: "荷物についてはご利用時にご相談ください",
        maxNoLuggageSuffix: "名（手荷物なし）",
        bookNow: "今すぐ予約",
      },
      
      // ステップ設定
      steps: ["車両選択", "約款同意", "情報入力", "予約確認"],
      stepDescriptions: [
        "お客様のご希望に応じた車種をお選びください",
        "予約に関する注意事項と個人情報利用条件をご確認ください",
        "お客様の個人情報とご連絡先をご入力ください",
        "ご予約内容をご確認・確定してください"
      ],
      
      // ナビゲーションボタン
      previous: "前へ",
      next: "次へ",
      submitting: "送信中...",
      confirm: "予約確定",
      
      // 車両選択
      vehicleTitle: "車両選択",
      vehicleCategories: {
        small: "小型車両",
        medium: "中型車両",
        large: "大型車両"
      },
      serviceTypes: {
        airportTransfer: "空港送迎サービス",
        charter: "チャーターサービス"
      },
      serviceTypeSelection: {
        title: "サービスタイプを選択"
      },
      vehicleSpecs: {
        passengers: "乗車",
        luggage: "荷物",
        withLuggage: "荷物有り乗車",
        withoutLuggage: "荷物無し乗車",
        seats: "座席数",
        length: "車長",
        luggageCount: "荷物数",
        price: "料金"
      },
      selectVehicle: "車両選択",
      cancelSelection: "選択解除",
      clickForDetails: "画像をクリックして詳細表示",
      noVehicles: "車両なし",
      noVehiclesMessage: "この車種は準備中です。他の車種をお選びください",
      
      // フォームフィールド
      formTitle: "情報入力",
      nameLabel: "お名前",
      namePlaceholder: "お名前をご入力ください",
      dateLabel: "ご予約日",
      tripTypeLabel: "行程種別",
      oneWay: "片道",
      roundTrip: "往復",
      returnDateLabel: "復路日",
      contactMethodLabel: "連絡方法",
      lineLabel: "LINE ID",
      linePlaceholder: "LINE IDをご入力ください",
      wechatLabel: "WeChat ID",
      wechatPlaceholder: "WeChat IDをご入力ください",
      emailLabel: "メールアドレス",
      emailPlaceholder: "メールアドレスをご入力ください",
      required: "*",
      
      // 確認ページ
      confirmationTitle: "予約確認",
      vehicleInfoSection: "車両情報",
      bookingInfoSection: "予約情報",
      vehicleTypeLabel: "車種",
      vehicleCategoryLabel: "車両カテゴリー",
      seatsLabel: "座席数",
      lengthLabel: "車長",
      luggageLabel: "荷物数",
      priceLabel: "料金",
      nameConfirmLabel: "お名前",
      dateConfirmLabel: "ご予約日",
      tripTypeConfirmLabel: "行程種別",
      returnDateConfirmLabel: "復路日",
      contactMethodConfirmLabel: "連絡方法",
      contactInfoConfirmLabel: "連絡先",
      confirmNotice: "上記内容にお間違いがないことをご確認の上、ご予約をお申し込みください。お選びいただいた連絡方法にて詳細をご連絡いたします。",
      
      // ホテル推薦
      hotelPromptTitle: "ホテル予約",
      hotelPromptMessage: "ホテルのご予約も同時にお申し込みされますか？ホテル予約サービスもご提供しております。",
      hotelYes: "はい、ホテルを予約したい",
      hotelNo: "今のところ不要",
      hotelLater: "後で検討する",
      
      // 車両詳細モーダル
      modalTitle: "車両詳細",
      seatLayout: "車内座席図（追加予定）",
      pricingSection: "料金説明",
      depositSection: "予約金",
      specialItemsSection: "特殊用品",
      regulationsSection: "車内規定",
      overtimeSection: "延長料金説明",
      
      // 料金説明
      priceIncluded: "表示料金に含まれるもの：",
      priceIncludedItems: "車両使用料、運転手賃金。",
      priceExcluded: "含まれないもの：",
      priceExcludedItems: "高速料金、駐車料金、宿泊費（8,000円/泊）、回送費、運転手食事代（3,000円/日）、運転手残業代。",
      priceEstimate: "1日の使用距離が300km以内、勤務時間が10時間以内の場合、高速料金、駐車料金、宿泊費、回送費、運転手食事代で1日約15,000円程度です。",
      
      // 予約金説明
      depositDescription: "ご予約成立後、カスタマーサービスよりご連絡し、料金の30%の予約金を申し受けます。",
      
      // 特殊用品
      specialItemsDescription: "乳幼児用安全シート、車椅子、ベビーカーなどが必要な場合は、ご利用行程備考欄にご記入ください。別途料金が発生いたします。",
      specialItemsPricing: "車椅子：1,000円/日、チャイルドシート：1,000円/日、ベビーカー：2,000円/日。",
      specialItemsPayment: "当日運転手に直接お支払いいただけます。これらの追加料金につき領収書が必要な場合は事前にお申し付けください。",
      
      // 車内規定
      regulationsDescription: "車内でのお食事はご遠慮ください。お客様の快適な旅のため、他のお客様にご迷惑をおかけしないよう、車酔いによる嘔吐などの状況も含め、車内での飲食、においの強い食品の持ち込みはお控えください。ご理解とご協力をお願いいたします。",
      
      // 延長料金説明
      overtimeDescription: "勤務時間は10時間を基準としております。延長は15分単位で計算し、15分未満でも15分として計算いたします。",
      overtimeRate: "15分延長ごとに1,250円を加算いたします。",
      
      // モーダルボタン
      modalClose: "閉じる",
      modalSelect: "この車両を選択",
      
      // 車両特徴
      features: {
        airCondition: "エアコン",
        audio: "オーディオ",
        gps: "GPSナビ",
        largeLuggage: "荷物スペース大",
        businessSeats: "ビジネスシート",
        largeStorage: "大容量収納",
        comfortSeats: "快適シート",
        luggageCompartment: "荷物室",
        luxurySeats: "高級シート",
        wifi: "WiFi",
        restroom: "トイレ"
      },
      
      // 車種名
      vehicleTypes: {
        economyCar: "エコノミーセダン",
        suvOffroad: "SUVオフロード",
        businessMpv: "ビジネスMPV",
        familyMpv: "ファミリーMPV",
        tourBus: "観光バス",
        luxuryTourBus: "高級観光バス",
        smallCar: "小型セダン",
        compactSuv: "コンパクトSUV",
        businessVan: "中型商用車",
        mpvMulti: "MPV多機能車",
        largeBus: "大型バス",
        luxuryBus: "高級バス"
      },
      
      // 画像説明
      imageAlts: {
        exterior: "外観",
        interior: "内装",
        luggage: "トランク",
        side: "側面",
        seats: "シート",
        storage: "収納スペース",
        luggageCompartment: "荷物室",
        luxurySeats: "高級シート",
        restroom: "トイレ"
      },
      
      // 単位
      units: {
        people: "名",
        seats: "席",
        meters: "m",
        luggageBoxes: "個の大型スーツケース",
        perDay: "/日"
      },
      
      successMessage: "予約が正常に送信されました！選択した連絡方法でご連絡いたします。",
      submitError : "送信失败しました。",
      
    
    },

    // ホテル予約ページ
    hotelbooking: {
      title: "ホテル予約",
      pageTitle: "厳選ホテル予約",
      subtitle: "日本各地の優良ホテルと提携し、最適な価格と心のこもったサービスをご提供します",
      consultation: {
        title: "専門コンサルタントがサービス",
        description: "下記のQRコードをスキャンして、企業WeChatを追加してください",
        subdescription: "最新の優待情報と専属予約サービスを取得",
        wechatLabel: "企業WeChat",
        features: {
          response: {
            icon: "⚡",
            title: "迅速な対応",
            description: "営業時間内5分以内に返信"
          },
          price: {
            icon: "💰",
            title: "優待価格",
            description: "団体予約で割引あり"
          },
          custom: {
            icon: "🎯",
            title: "カスタマイズサービス",
            description: "ニーズに応じてホテルを推薦"
          }
        }
      },
      hotels: [
        {
          id: 1,
          name: "東京ヒルトンホテル",
          location: "新宿区",
          features: ["温泉", "フィットネスセンター", "ビジネスセンター"],
          image: "🏨"
        },
        {
          id: 2,
          name: "京都フォーシーズンズホテル",
          location: "東山区",
          features: ["日本庭園", "茶室", "ミシュランレストラン"],
          image: "🏯"
        },
        {
          id: 3,
          name: "大阪マリオットホテル",
          location: "阿倍野区",
          features: ["スカイバー", "インフィニティプール", "展望台"],
          image: "🌆"
        },
        {
          id: 4,
          name: "箱根温泉旅館",
          location: "箱根町",
          features: ["プライベート温泉", "伝統料理", "富士山ビュー"],
          image: "♨️"
        },
        {
          id: 5,
          name: "札幌グランドホテル",
          location: "中央区",
          features: ["スキー場送迎", "温泉", "海鮮料理"],
          image: "❄️"
        },
        {
          id: 6,
          name: "沖縄ビーチリゾート",
          location: "恩納村",
          features: ["プライベートビーチ", "ウォータースポーツ", "SPAセンター"],
          image: "🏖️"
        }
      ]
    },

    // よくある質問ページ
    question: {
      title: "よくある質問",
      subtitle: "日本旅行サービスのよくあるご質問にお答えします",
      faqs: [
        {
          id: 1,
          question: "貸切サービスの予約手順はどのようになっていますか？",
          answer: "貸切サービスの予約手順は簡単です：1. ご希望の車種と日程をお選びください；2. 詳細な旅行情報とご連絡先をご入力ください；3. 24時間以内にカスタマーサービスがご連絡し、行程を確認いたします；4. 予約金のお支払い後、予約完了となります。専門ドライバーと安全な車両をご提供し、快適な日本旅行をお約束いたします。"
        },
        {
          id: 2,
          question: "ホテル予約はどのくらい前に行う必要がありますか？",
          answer: "最低でも3-7日前のご予約をお勧めいたします。特に桜の季節や紅葉の季節などの観光繁忙期には、2-4週間前のご予約をお勧めします。お客様のご要望と予算に応じて、伝統的な日本旅館、ビジネスホテル、リゾートホテルなど様々な選択肢をご提案いたします。予約確定後、詳細な宿泊情報をお送りいたします。"
        },
        {
          id: 3,
          question: "カスタマーサービスへの連絡方法や予約キャンセルはどうすればよいですか？",
          answer: "様々な方法でお問い合わせいただけます：WeChat、LINE、メール、お電話。カスタマーサービスチームが営業時間内に迅速に対応いたします。予約キャンセルについては、ご出発の48時間前までにご連絡ください。具体的な状況に応じて払い戻し手続きを行います。緊急時は24時間カスタマーサービスホットラインまでお電話ください。"
        }
      ],
      contactSection: {
        title: "他にご質問はございますか？",
        description: "その他ご不明な点がございましたら、お気軽にカスタマーサービスチームまでお問い合わせください",
        button: "お問い合わせ"
      }
    },

    // お問い合わせページ
    contact: {
      title: "お問い合わせ",
      menu: {
        whatsapp: "WhatsApp",
        wechat: "WeChat",
        mail: "メール"
      },
      whatsapp: {
        title: "Whatsapp相談",
        description: "上記QRコードをスキャンしてWhatsAppでお問い合わせください"
      },
      wechat: {
        title: "WeChat相談",
        description: "上記QRコードをスキャンしてWeChatでお問い合わせください"
      },
      mail: {
        title: "メール相談",
        nameLabel: "お名前",
        namePlaceholder: "お名前をご入力ください",
        emailLabel: "メールアドレス",
        emailPlaceholder: "example@email.com",
        messageLabel: "お問い合わせ内容",
        messagePlaceholder: "お問い合わせ内容を詳しくお書きください",
        submit: "送信",
        success: "メッセージが正常に送信されました！"
      }
    },

    // 会社概要ページ
    companyProfile: {
      title: "会社概要",
      presidentMessage: {
        title: "代表挨拶",
        presidentName: "李 阳阳",
        presidentTitle: "代表取締役社長",
        paragraph1: "ARESCOJP株式会社の公式ウェブサイトをご覧いただき、ありがとうございます。",
        paragraph2: "2024年の設立以来、私どもは常にお客様に安心・安全・快適な旅行体験をご提供することを使命とし、日本国内外の旅行サービス業に取り組んでまいりました。特に近年のインバウンド観光の拡大に伴い、海外のお客様に日本の魅力を十分に感じていただけるよう、きめ細やかなサービスと専門知識によるサポートをご提供することに努めております。",
        paragraph3: "私どもは単なる交通手段やサービスの提供にとどまらず、お客様お一人お一人にとって忘れられない特別な時間を創り出すことを重視しております。貸切サービス、宿泊手配、観光ガイド、通訳翻訳など、旅行に関わる様々な分野において、専門チームがお客様の多様なご要望にお応えいたします。",
        paragraph4: "今後も変化し続ける観光業界において、革新的なサービスと伝統のおもてなしの心を融合させ、お客様により一層ご満足いただけるサービスのご提供に努めてまいります。",
        signatureCompany: "ARESCOJP株式会社",
        signaturePosition: "代表取締役社長　李 阳阳"
      },
      companyInfo: {
        labels: {
          companyName: "会社名",
          established: "設立",
          headquarters: "本社",
          business: "事業内容",
          representative: "代表者",
          capital: "資本金"
        },
        values: {
          companyName: "株式会社ARES",
          established: "2024年6月6日",
          headquarters: "〒107-0062\n東京都港区南青山3-1-36青山丸竹ビル6F",
          business: "1.各種コンサルティング業務\n2.各種イベントの企画、制作及び実施\n3.各種商品の企画、研究、開発、製造、販壳及び\n4.飲食店,料理店の経営及ぴ管理\n5.酒類の販壳、卸売並ぴにその輸出入\n6.不動産の所有、売買、賃贷、仲介、媒介、\n7.旅行業法に基づく旅行業\n8.ホテル·旅館等の宿泊、観光及び娯楽施設の経営\n9.労働者派遣事業及ぴ有料職業紹介事業\n10.一般乘用旅客自動車運送事業、一般貨物自\n車運送事業及ぴ貨物軽自動車運送事業\n11.自動車·中古自動車等車両の販売、リ一 12.美容教室·整体院·理容店·美容院·エ\nロンの経営\n13.医療ツ一リズムに関するセミナ一の企画、\n14.貿易業\n15.古物営業法に基つく古物の売買及ぴ輸出入\n16.EC(電子商取引)サイト、その他各種クエ\n壳、配信、運常及ぴ管理\n17.映像·動画コンテンツ及ひSNSを活用したマ一ケティング事業\n18.IT関連事業\n19.上記各号に附带関連する一切の業務",
          representative: "代表取締役社長　李　阳阳",
          capital: "6，660，000円"
        }
      },
      location: {
        title: "会社所在地",
        subtitle: "📍 交通案内",
        address: "〒107-0062 東京都港区南青山3-1-36青山丸竹ビル6F\nTel: 080-4779-8044",
        stations: "最寄り駅：\n• 東京メトロ銀座線『外苑前駅』300m 徒歩6分\n• 東京メトロ千代田線『表参道駅』550m 徒歩9分（A3出口）"
      },
      achievements: {
        title: "サービス実績",
        tableHeaders: {
          year: "年度",
          groupTours: "受入団体数",
          totalPeople: "サービス総人数"
        },
        data: [
          {
            year: "2024年",
            groupTours: "15団体",
            totalPeople: "423名"
          }
        ]
      }
    },

    // 団体ガイドページ
    grouptravel: {
      title: "団体ガイド",
      subtitle: "厳選された日本旅行ガイド、日本満喫のお手伝い",
      
      // カードコンポーネントテキスト
      duration: "行程：",
      
      // ページネーションコンポーネントテキスト
      paginationInfo: "{currentPage} ページ / 全 {totalPages} ページ",
      previousPage: "前のページ",
      nextPage: "次のページ",
      
      // 詳細ページテキスト
      backToList: "← ガイド一覧に戻る",
      returnToList: "ガイド一覧に戻る",
      notFoundTitle: "ガイドが存在しません",
      notFoundText: "申し訳ございません。お探しの旅行ガイドは存在しないか削除されています。",
      relatedTitle: "関連おすすめ",
      
      // メタ情報ラベル
      durationLabel: "行程期間：",
      difficultyLabel: "難易度：",
      travelGuides: [
        {
          id: "tokyo-guide",
          title: "東京必見スポット",
          subtitle: "日本の首都の魅力を探索",
          image: "/images/grouptravel/Top.png",
          summary: "日本の首都である東京は、豊かな歴史文化と現代都市の風貌を持っています。伝統的な寺院から現代の摩天楼まで、東京は観光客にユニークな体験を提供します。",
          content: `
            <h2>東京必見スポット詳細ガイド</h2>
            <p>東京は活力に満ちた現代都市でありながら、深い伝統文化も保持しています。以下は東京の必見スポットです：</p>
            
            <h3>1. 浅草寺</h3>
            <p>浅草寺は東京最古の寺院で、645年に建立されました。有名な雷門と仲見世通り商店街があり、伝統的な日本文化を体験する絶好の場所です。</p>
            
            <h3>2. 東京スカイツリー</h3>
            <p>高さ634メートルの東京スカイツリーは世界第2位の高層建築物で、ここから東京都市全体のパノラマを見渡すことができます。</p>
            
            <h3>3. 銀座</h3>
            <p>銀座は東京で最も繁華な商業地区の一つで、世界各国の高級ブランドと日本の伝統工芸品店が集まっています。</p>
            
            <h3>4. 新宿</h3>
            <p>新宿は東京の商業・娯楽の中心地で、多数のショッピングセンター、レストラン、ナイトライフスポットがあります。</p>
            
            <h3>交通のご案内</h3>
            <p>JRパスや東京メトロ一日券の購入をお勧めします。東京各スポット間の移動が便利になります。</p>
            
            <h3>グルメおすすめ</h3>
            <p>東京のラーメン、寿司、天ぷらなどの伝統料理をお見逃しなく。築地市場や新宿の小路には多くの本格的な日本料理店があります。</p>
          `,
          tags: ["都市", "文化", "ショッピング", "グルメ"],
          duration: "2-3日",
          difficulty: "易しい"
        }
      ],
      pagination: {
        info: "{currentPage} ページ / 全 {totalPages} ページ",
        previous: "前のページ",
        next: "次のページ"
      }
    },

    // ===== フッター部分 =====
    footer: {
      subtitle: "日本専門旅行サービスプラットフォーム",
      services: {
        title: "私たちのサービス",
        items: {
          carbooking: "貸切サービス →",
          grouptravel: "団体ガイド →",
          hotelbooking: "ホテル予約 →",
          contact: "お問い合わせ →",
          travelguide: "旅行ガイド →",
          faq: "よくある質問 →"
        }
      },
      address: {
        title: "会社所在地",
        postal: "〒107-0062",
        city: "東京都港区南青山3-1-36",
        building: "青山丸竹ビル6F"
      },
      social: {
        title: "フォローする",
        phone: "080-4779-8044",
        email: "info@arescojp.com"
      },
      copyright: "© Copyright 2025 ARESCOJP株式会社, All rights Reserved."
    },

    // ===== 共通要素 =====
    common: {
      loading: "読み込み中...",
      error: "エラーが発生しました",
      retry: "再試行",
      errorModal: {
        title: "送信失敗",
        actions: {
          cancel: "キャンセル",
          retry: "再試行"
        }
      },
      // 共通予約条項
      bookingTerms: {
        title: "予約須知",
        notice: "より良いサービスをご提供するため、有効な連絡先を必ずご入力ください。スタッフがお客様とご連絡を取らせていただきます。ご連絡が取れない場合、ご注文はキャンセルとなります。",
        sections: {
          purpose: {
            title: "個人情報の利用目的",
            description: "お客様からお預かりした個人情報は、以下の目的にのみ使用いたします。",
            items: {
              common: [
                "本サービスの顧客管理",
                "本サービスの運営に必要な事項のご連絡"
              ],
              hotel: "ホテル予約サービスのご提供",
              car: "貸切サービスのご提供"
            }
          },
          provision: {
            title: "個人情報の提供について",
            description: "お客様の同意を得る場合や法令により求められる場合を除き、取得した個人情報を第三者に提供することはございません。"
          },
          delegation: {
            title: "個人情報の委託について",
            description: "当社では、利用目的の達成に必要な範囲内で個人情報を外部に委託する場合があります。この場合、委託先との間で個人情報保護契約を締結するなど、適切な監督を行います。"
          },
          security: {
            title: "個人情報の安全管理",
            description: "当社では、個人情報の漏洩を防止するため、適切な安全管理措置を講じます。"
          },
          consequences: {
            title: "個人情報を提供されない場合の結果",
            description: "必要な情報をお預かりできない場合、該当するサービスをご提供できない場合がございますのでご了承ください。"
          },
          procedures: {
            title: "個人情報の開示・訂正・削除・利用停止の手続き",
            description: "当社では、お客様の個人情報の開示・訂正・削除・利用停止の手続きを定めております。ご本人様確認の上、回答させていただきます。個人情報の開示・訂正・削除・利用停止の具体的な手続きについては、お電話にてお問い合わせください。"
          }
        },
        agreement: "上記の予約須知および個人情報利用条項を読み、同意いたします"
      }
    }
  },

  // 英語版本
  en: {
    // ===== Header Section =====
    // Company basic information (site-wide)
    company: {
      name: "ARESCOJP株式会社",
      slogan: "Professional Japan Travel Service Platform",
      contact: {
        phone: "080-4779-8044",
        fax: "+81-42-497-1567",
        email: "info@arescojp.com"
      }
    },
    // Header navigation
    header: {
      // Top header contact information
      topHeader: {
        phoneAlt: "Phone icon",
        faxAlt: "Fax icon",
        bookingButton: "🚗 Book Car"
      },
      // Main navigation menu
      navigation: {
        home: "Home",
        carbooking: "Charter Service",
        grouptravel: "Group Tours",
        hotelbooking: "Hotel Booking",
        question: "FAQ",
        contact: "Contact Us",
        companyprofile: "Company Profile"
      }
    },

    // ===== Page Contents =====

    // Homepage
    homepage: {
      title: {
        main: "Travel",
        subtitle: "Professional Japan Travel Service Platform"
      },
      scrollingBar: "🌸 Welcome to ARESCOJP Professional Japan Travel Service Platform 🎌 Providing charter services, hotel bookings, travel consultations and one-stop services 📞 Phone consultation: 080-4779-8044 ✉️ Email: info@arescojp.com 🚗 Professional drivers, safe and reliable 🏨 Selected quality accommodations 🗾 Customized travel itineraries"
    },

    // Charter booking page
    carbooking: {
      title: "Charter Booking",
      // Vehicles (centralized copy and images)
      vehicles: [
        {
          model: "7-Seater (Toyota Alphard)",
          recommended: "Recommended for 1–6 guests",
          max: "6",
          seats: "7 seats (including driver)",
          length: "Length 5m",
          luggage: "1–6 (26-inch suitcases)",
          images: { vehicle: carImage1, seats: seat7 },
        },
        {
          model: "10-Seater (Toyota Hiace)",
          recommended: "Recommended for 5–9 guests",
          max: "9",
          seats: "15 seats (including driver)",
          length: "Length 5.3m",
          luggage: "1–10 (26-inch suitcases)",
          images: { vehicle: carImage2, seats: seat10 },
        },
        {
          model: "18 Seats + 5 Auxiliary (Toyota Coaster)",
          recommended: "Recommended for 10–17 guests",
          max: "22",
          seats: "18 seats (including driver) + 5 auxiliary",
          length: "Length 7m",
          luggage: "1–17 (26-inch suitcases)",
          images: { vehicle: carImage3, seats: seat18 },
        },
        {
          model: "28 Seats (Mitsubishi Bus)",
          recommended: "Recommended for 20–28 guests",
          max: "28",
          seats: "30 seats (including driver)",
          length: "Length 9m",
          luggage: "1–25 (26-inch suitcases)",
          images: { vehicle: carImage4, seats: seat30 },
        },
        {
          model: "49 Seats + 11 Auxiliary (Mitsubishi Bus)",
          recommended: "Recommended for 49–60 guests",
          max: "60",
          seats: "50 seats (including driver) + 11 auxiliary",
          length: "Length 12m",
          luggage: "1–35 (26-inch suitcases)",
          images: { vehicle: carImage5, seats: seat60 },
        },
      ],

      // Reservation form (charter / transfer)
      reservation: {
        serviceTypeLabel: "Service Type",
        serviceTypeOptions: {
          charter: "Charter Tour",
          transfer: "Airport Transfer",
        },
        charter: {
          labels: {
            name: "Name",
            phone: "Phone Number",
            phoneCountryPlaceholder: "Country Code",
            phoneNumberPlaceholder: "Number",
            wechat: "WeChat ID",
            hotel: "Hotel Name",
            email: "Email Address",
            passengers: "Passengers",
            startTime: "Start Time",
            endTime: "End Time",
            notes: "Notes",
          }
        },
        transfer: {
          kindLabel: "Transfer Type",
          kindOptions: {
            pickup: "Pickup",
            dropoff: "Drop-off",
          },
          routeLabel: "Airport Route",
          routes: [
            "Narita Airport",
            "Haneda Airport",
            "Kansai Airport",
            "New Chitose Airport",
            "Fukuoka Airport",
            "Naha Airport",
            "Others (please note in the remarks)",
          ],
          labels: {
            name: "Name",
            passengers: "Passengers",
            luggage: "Luggage Count",
            phone: "Phone Number",
            phoneCountryPlaceholder: "Country Code",
            phoneNumberPlaceholder: "Number",
            hotel: "Hotel Name",
            wechat: "WeChat ID",
            email: "Email Address",
            flightNo: "Flight No.",
            flightTime: "Flight Time",
            notes: "Notes",
          }
        },
        phone: {
          countryOptions: [
            { value: "+81", label: "+81 Japan" },
            { value: "+86", label: "+86 China" },
            { value: "+852", label: "+852 Hong Kong" },
            { value: "+853", label: "+853 Macao" },
            { value: "+886", label: "+886 Taiwan" },
            { value: "+82", label: "+82 South Korea" },
            { value: "+65", label: "+65 Singapore" },
            { value: "+60", label: "+60 Malaysia" },
            { value: "+62", label: "+62 Indonesia" },
            { value: "+63", label: "+63 Philippines" },
            { value: "+66", label: "+66 Thailand" },
            { value: "+84", label: "+84 Vietnam" },
            { value: "+91", label: "+91 India" },
            { value: "+92", label: "+92 Pakistan" },
            { value: "+94", label: "+94 Sri Lanka" },
            { value: "+95", label: "+95 Myanmar" },
            { value: "+880", label: "+880 Bangladesh" },
            { value: "+976", label: "+976 Mongolia" },
            { value: "+977", label: "+977 Nepal" },
            { value: "+855", label: "+855 Cambodia" },
            { value: "+856", label: "+856 Laos" },
            { value: "+673", label: "+673 Brunei" },
            { value: "+971", label: "+971 UAE" },
            { value: "+972", label: "+972 Israel" },
            { value: "+974", label: "+974 Qatar" },
            { value: "+973", label: "+973 Bahrain" },
            { value: "+968", label: "+968 Oman" },
            { value: "+965", label: "+965 Kuwait" },
            { value: "+964", label: "+964 Iraq" },
            { value: "+98", label: "+98 Iran" },
            { value: "+90", label: "+90 Turkey" },
            { value: "+44", label: "+44 United Kingdom" },
            { value: "+49", label: "+49 Germany" },
            { value: "+33", label: "+33 France" },
            { value: "+39", label: "+39 Italy" },
            { value: "+34", label: "+34 Spain" },
            { value: "+31", label: "+31 Netherlands" },
            { value: "+32", label: "+32 Belgium" },
            { value: "+41", label: "+41 Switzerland" },
            { value: "+43", label: "+43 Austria" },
            { value: "+46", label: "+46 Sweden" },
            { value: "+47", label: "+47 Norway" },
            { value: "+45", label: "+45 Denmark" },
            { value: "+48", label: "+48 Poland" },
            { value: "+36", label: "+36 Hungary" },
            { value: "+420", label: "+420 Czech Republic" },
            { value: "+421", label: "+421 Slovakia" },
            { value: "+40", label: "+40 Romania" },
            { value: "+359", label: "+359 Bulgaria" },
            { value: "+30", label: "+30 Greece" },
            { value: "+351", label: "+351 Portugal" },
            { value: "+353", label: "+353 Ireland" },
            { value: "+358", label: "+358 Finland" },
            { value: "+380", label: "+380 Ukraine" },
            { value: "+375", label: "+375 Belarus" },
            { value: "+354", label: "+354 Iceland" },
            { value: "+386", label: "+386 Slovenia" },
            { value: "+385", label: "+385 Croatia" },
            { value: "+372", label: "+372 Estonia" },
            { value: "+371", label: "+371 Latvia" },
            { value: "+370", label: "+370 Lithuania" },
            { value: "+357", label: "+357 Cyprus" },
            { value: "+356", label: "+356 Malta" },
            { value: "+1", label: "+1 USA/Canada" },
          ]
        },
        submitLabel: "Submit Request",
        submitLoading: "Submitting...",
      },

      // Card labels
      cardLabels: {
        seat: "Seats",
        recommended: "Recommended",
        luggage: "Luggage",
        remarkPrefix: "Note",
        remarkText: "Please consult with us regarding luggage when using the service",
        maxNoLuggageSuffix: " people (no luggage)",
        bookNow: "Book Now",
      },
      
      submitError: "Submission failed",
      successMessage: "Booking submitted successfully! We will contact you through your selected contact method.",
    },

    // Hotel booking page
    hotelbooking: {
      title: "Hotel Booking",
      pageTitle: "Selected Hotel Booking",
      subtitle: "We cooperate with quality hotels across Japan to provide you with the best prices and thoughtful service",
      consultation: {
        title: "Professional Consultants at Your Service",
        description: "Scan the QR code below to add our Enterprise WeChat",
        subdescription: "Get the latest offers and exclusive booking services",
        wechatLabel: "Enterprise WeChat",
        features: {
          response: {
            icon: "⚡",
            title: "Quick Response",
            description: "Reply within 5 minutes during business hours"
          },
          price: {
            icon: "💰",
            title: "Preferential Prices",
            description: "Group booking discounts available"
          },
          custom: {
            icon: "🎯",
            title: "Customized Service",
            description: "Hotel recommendations based on your needs"
          }
        }
      },
      hotels: [
        {
          id: 1,
          name: "Tokyo Hilton Hotel",
          location: "Shinjuku",
          features: ["Hot Spring", "Fitness Center", "Business Center"],
          image: "🏨"
        },
        {
          id: 2,
          name: "Kyoto Four Seasons Hotel",
          location: "Higashiyama",
          features: ["Japanese Garden", "Tea Room", "Michelin Restaurant"],
          image: "🏯"
        },
        {
          id: 3,
          name: "Osaka Marriott Hotel",
          location: "Abeno",
          features: ["Sky Bar", "Infinity Pool", "Observation Deck"],
          image: "🌆"
        },
        {
          id: 4,
          name: "Hakone Onsen Ryokan",
          location: "Hakone",
          features: ["Private Onsen", "Traditional Cuisine", "Mt. Fuji View"],
          image: "♨️"
        },
        {
          id: 5,
          name: "Sapporo Grand Hotel",
          location: "Chuo",
          features: ["Ski Resort Shuttle", "Hot Spring", "Seafood Cuisine"],
          image: "❄️"
        },
        {
          id: 6,
          name: "Okinawa Beach Resort",
          location: "Onna",
          features: ["Private Beach", "Water Sports", "SPA Center"],
          image: "🏖️"
        }
      ]
    },

    // FAQ page
    question: {
      title: "Frequently Asked Questions",
      subtitle: "Answering common questions about Japan travel services",
      faqs: [
        {
          id: 1,
          question: "What is the booking process for charter services?",
          answer: "The charter service booking process is simple: 1. Select your preferred vehicle type and dates; 2. Fill in detailed travel information and contact details; 3. Our customer service team will contact you within 24 hours to confirm the itinerary; 4. Booking is complete after deposit payment. We provide professional drivers and safe vehicles to ensure your comfortable and pleasant trip to Japan."
        },
        {
          id: 2,
          question: "How far in advance should hotel bookings be made?",
          answer: "We recommend booking hotels at least 3-7 days in advance, especially during peak tourist seasons like cherry blossom season and autumn foliage season, we suggest booking 2-4 weeks in advance. We will recommend suitable hotels based on your needs and budget, including traditional Japanese inns, business hotels, resorts, and various other options. After booking confirmation, we will send you detailed accommodation information."
        },
        {
          id: 3,
          question: "How to contact customer service or cancel bookings?",
          answer: "You can contact us through various methods: WeChat, LINE, email, or phone. Our customer service team will respond promptly to your inquiries during business hours. For booking cancellations, please contact us 48 hours before departure, and we will handle refund matters based on specific circumstances. For emergencies, you can contact our 24-hour customer service hotline anytime."
        }
      ],
      contactSection: {
        title: "Have other questions?",
        description: "If you have any other questions, please feel free to contact our customer service team",
        button: "Contact Us"
      }
    },

    // Contact page
    contact: {
      title: "Contact Us",
      menu: {
        whatsapps: "WhatsApps",
        wechat: "WeChat",
        mail: "Mail"
      },
      whatsapps: {
        title: "WhatsApps Consultation",
        description: "Please scan the QR code above to contact us via WhatsApps"
      },
      wechat: {
        title: "WeChat Consultation",
        description: "Please scan the QR code above to contact us via WeChat"
      },
      mail: {
        title: "Email Consultation",
        nameLabel: "Name",
        namePlaceholder: "Please enter your name",
        emailLabel: "Email Address",
        emailPlaceholder: "example@email.com",
        messageLabel: "Inquiry Content",
        messagePlaceholder: "Please describe your inquiry in detail",
        submit: "Send",
        success: "Message sent successfully!"
      }
    },

    // Company profile page
    companyProfile: {
      title: "Company Profile",
      presidentMessage: {
        title: "President's Message",
        presidentName: "LI Yoyo",
        presidentTitle: "Representative Director and President",
        paragraph1: "Thank you for visiting the official website of ARESCOJP Co., Ltd.",
        paragraph2: "Since our establishment in 2024, we have been committed to providing customers with safe, secure, and comfortable travel experiences as our mission in the domestic and international travel service industry in Japan. Particularly with the recent expansion of inbound tourism, we strive to provide meticulous services and professional knowledge support so that overseas customers can fully experience the charm of Japan.",
        paragraph3: "We value not only providing transportation and services but also creating unforgettable special moments for each customer. In various fields related to travel such as charter services, accommodation arrangements, tour guides, interpretation and translation, our professional team will meet customers' diverse needs.",
        paragraph4: "In the future, in the ever-changing tourism industry, we will continue to integrate innovative services with traditional hospitality, striving to provide services that satisfy customers even more.",
        signatureCompany: "ARESCOJP Co., Ltd.",
        signaturePosition: "Representative Director and President LI Yoyo"
      },
      companyInfo: {
        labels: {
          companyName: "Company Name",
          established: "Established",
          headquarters: "Headquarters",
          business: "Business Content",
          representative: "Representative",
          capital: "Capital"
        },
        values: {
          companyName: "ARES Co., Ltd.",
          established: "June 6, 2024",
          headquarters: "Aoyama Marutake Building 6F\n3-1-36 Minami-Aoyama, Minato-ku, Tokyo 〒107-0062, Japan",
          business: "1. Various consulting services\n2. Planning, production and implementation of various events\n3. Planning, research, development, manufacturing and sales of various products\n4. Operation and management of restaurants and dining businesses\n5. Retail, wholesale and import/export of alcoholic beverages\n6. Ownership, sales, leasing, brokerage and intermediation of real estate\n7. Travel business in accordance with the Travel Agency Act\n8. Operation of hotels, inns, tourism and entertainment facilities\n9. Worker dispatching and paid employment placement services\n10. General passenger car transportation, general cargo transportation and light cargo vehicle transportation\n11. Sales and leasing of automobiles and used vehicles\n12. Operation of beauty schools, osteopathic/therapy clinics, barbershops, beauty salons and esthetic salons\n13. Planning of seminars related to medical tourism\n14. Trading business\n15. Purchase/sale and import/export of antiques in accordance with the Antique Dealings Act\n16. Operation and management of e-commerce (EC) sites and other content distribution platforms\n17. Marketing using video content and SNS\n18. IT-related business\n19. All incidental and related businesses to the above",
          representative: "Representative Director: Yangyang Li",
          capital: "JPY 6,660,000"
        }
      },
      location: {
        title: "Company Location",
        subtitle: "📍 Transportation Information",
        address: "6F Aoyama Marutake Building, 3-1-36 Minami-Aoyama, Minato-ku, Tokyo 107-0062, Japan\nTel: 080-4779-8044",
        stations: "Nearest stations:\n• Tokyo Metro Ginza Line “Gaiemmae Station” — 300m (6-minute walk)\n• Tokyo Metro Chiyoda Line “Omotesando Station” — 550m (9-minute walk, Exit A3)"
      },
      achievements: {
        title: "Service Achievements",
        tableHeaders: {
          year: "Year",
          groupTours: "Groups Served",
          totalPeople: "Total People Served"
        },
        data: [
          {
            year: "2024",
            groupTours: "15 groups",
            totalPeople: "423 people"
          }
        ]
      }
    },

    // Group travel page
    grouptravel: {
      title: "Group Tours",
      subtitle: "Selected Japan travel guides to help you enjoy Japan to the fullest",
      
      // Card component text
      duration: "Duration:",
      
      // Pagination component text
      paginationInfo: "Page {currentPage} / Total {totalPages} pages",
      previousPage: "Previous",
      nextPage: "Next",
      
      // Detail page text
      backToList: "← Back to Guide List",
      returnToList: "Return to Guide List",
      notFoundTitle: "Guide not found",
      notFoundText: "Sorry, the travel guide you are looking for does not exist or has been deleted.",
      relatedTitle: "Related Recommendations",
      
      // Meta information labels
      durationLabel: "Duration:",
      difficultyLabel: "Difficulty Level:",
      travelGuides: [
        {
          id: "tokyo-guide",
          title: "Tokyo Must-Visit Spots",
          subtitle: "Exploring the charm of Japan's capital",
          image: "/images/grouptravel/Top.png",
          summary: "As Japan's capital, Tokyo boasts rich historical culture and modern urban landscapes. From traditional temples to modern skyscrapers, Tokyo offers unique experiences for visitors.",
          content: `
            <h2>Tokyo Must-Visit Spots Detailed Guide</h2>
            <p>Tokyo is a vibrant modern metropolis that also preserves deep traditional culture. Here are Tokyo's must-visit spots:</p>
            
            <h3>1. Senso-ji Temple</h3>
            <p>Senso-ji Temple is Tokyo's oldest temple, built in 645. It features the famous Thunder Gate and Nakamise Shopping Street, making it an excellent place to experience traditional Japanese culture.</p>
            
            <h3>2. Tokyo Skytree</h3>
            <p>At 634 meters tall, Tokyo Skytree is the world's second tallest structure, offering panoramic views of the entire Tokyo metropolitan area.</p>
            
            <h3>3. Ginza</h3>
            <p>Ginza is one of Tokyo's most prosperous commercial districts, gathering world-class luxury brands and traditional Japanese craft shops.</p>
            
            <h3>4. Shinjuku</h3>
            <p>Shinjuku is Tokyo's commercial and entertainment center, with numerous shopping centers, restaurants, and nightlife venues.</p>
            
            <h3>Transportation Tips</h3>
            <p>We recommend purchasing a JR Pass or Tokyo Metro day pass for convenient travel between Tokyo's attractions.</p>
            
            <h3>Food Recommendations</h3>
            <p>Don't miss Tokyo's ramen, sushi, tempura, and other traditional cuisines. Tsukiji Market and Shinjuku's alleys have many authentic Japanese restaurants.</p>
          `,
          tags: ["City", "Culture", "Shopping", "Food"],
          duration: "2-3 days",
          difficulty: "Easy"
        }
      ],
      pagination: {
        info: "Page {currentPage} / Total {totalPages} pages",
        previous: "Previous",
        next: "Next"
      }
    },

    // ===== Footer Section =====
    footer: {
      subtitle: "Professional Japan Travel Service Platform",
      services: {
        title: "Our Services",
        items: {
          carbooking: "Charter Service →",
          grouptravel: "Group Tours →",
          hotelbooking: "Hotel Booking →",
          contact: "Contact Us →",
          travelguide: "Travel Guides →",
          faq: "FAQ →"
        }
      },
      address: {
        title: "Company Address",
        postal: "〒107-0062",
        city: "3-1-36 Minami-Aoyama, Minato-ku, Tokyo",
        building: "Aoyama Marutake Building 6F"
      },
      social: {
        title: "Follow Us",
        phone: "080-4779-8044",
        email: "info@arescojp.com"
      },
      copyright: "© Copyright 2025 ARESCOJP Co., Ltd., All rights Reserved."
    },

    // ===== Common Elements =====
    common: {
      loading: "Loading...",
      error: "Error occurred",
      retry: "Retry",
      errorModal: {
        title: "Submission Failed",
        actions: {
          cancel: "Cancel",
          retry: "Retry"
        }
      },
      // Common booking terms
      bookingTerms: {
        title: "Booking Requirements",
        notice: "To provide you with better service, please fill in valid contact information so that staff can communicate with you. If we cannot reach you, the order will be cancelled.",
        sections: {
          purpose: {
            title: "Purpose of Personal Information Use",
            description: "Personal information received from customers will only be used for the following purposes.",
            items: {
              common: [
                "Customer management of this service",
                "Communication of matters necessary for operating this service"
              ],
              hotel: "Provision of hotel booking services",
              car: "Provision of charter services"
            }
          },
          provision: {
            title: "Regarding Provision of Personal Information",
            description: "We will not provide acquired personal information to third parties unless we obtain your consent or are required by law."
          },
          delegation: {
            title: "Regarding Delegation of Personal Information",
            description: "Our company may delegate personal information to external parties within the scope necessary to achieve the purpose of use. We will take measures such as signing personal information protection agreements with these subcontractors and conduct appropriate supervision."
          },
          security: {
            title: "Security Management of Personal Information",
            description: "Our company will take appropriate security management measures to prevent leakage of personal information."
          },
          consequences: {
            title: "Consequences of Not Providing Personal Information",
            description: "Please note that if we do not receive necessary information, we may not be able to provide corresponding services."
          },
          procedures: {
            title: "Procedures for Disclosure, Correction, Deletion, and Suspension of Use of Personal Information",
            description: "Our company has established procedures for disclosure, correction, deletion, and suspension of use of customer personal information. We will respond after confirming your identity. For specific procedures regarding disclosure, correction, deletion, or suspension of use of personal information, please contact us by phone."
          }
        },
        agreement: "I have read and agree to the above booking requirements and personal information usage terms"
      }
    }
  }
}

// 旅行攻略数据工具函数
export const paginateData = (data, pageSize = 6) => {
  const pages = []
  for (let i = 0; i < data.length; i += pageSize) {
    pages.push(data.slice(i, i + pageSize))
  }
  return pages
}

// 根据ID获取单个攻略
export const getTravelGuideById = (id) => {
  const guides = texts.zh.grouptravel.travelGuides
  return guides.find(guide => guide.id === id)
}

// 获取相关攻略（基于标签）
export const getRelatedGuides = (currentId, limit = 3) => {
  const guides = texts.zh.grouptravel.travelGuides
  const currentGuide = getTravelGuideById(currentId)
  if (!currentGuide) return []
  
  const related = guides
    .filter(guide => guide.id !== currentId)
    .filter(guide => guide.tags.some(tag => currentGuide.tags.includes(tag)))
    .slice(0, limit)
  
  return related
}

export default texts
